"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldContainerAttributes = exports.helperAttributes = exports.selectArrowAttrs = exports.iconAttributes = exports.warningMsgAttributes = exports.errorMsgAttributes = exports.counterAttributes = exports.labelAttributes = exports.selectAttributes = exports.textareaAttributes = exports.inputAttributes = exports.conditionalAttributes = exports.commonAttributes = void 0;

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _utils = require("../utils");

var _fieldUtils = require("./fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Generate common html attributes for fields
 * @param  {String}  fieldName - name of the field
 * @param  {Object}  [atts] - standard html attributes to include
 * @param  {boolean} isRequiredField - whether the field should be marked as required
 * @param  {boolean} isInvalid - whether the field should be marked as invalid
 * @return {Object} common html attributes for fields <input> <select> <textarea>
 */
var commonAttributes = function commonAttributes(_ref) {
  var fieldName = _ref.fieldName,
      atts = _ref.atts,
      isRequiredField = _ref.isRequiredField,
      isInvalid = _ref.isInvalid;
  var ids = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  return _objectSpread({
    id: ids.input.id,
    name: fieldName,
    'aria-required': (0, _fieldUtils.boolToString)(isRequiredField),
    'aria-invalid': (0, _fieldUtils.boolToString)(isInvalid)
  }, atts);
};
/**
 * Generate conditional html attributes for fields
 * @param {String} fieldName - name of the field
 * @param {String} label - value of the label for the field
 * @param {String} [helper=''] - (optional) help text that would be provided for the field
 * @param {boolean} [isInvalid=false] - (optional) whether the field should be marked as invalid
 * @return {Object} conditional html attributes for fields <input> <select> <textarea>
 */


exports.commonAttributes = commonAttributes;

var conditionalAttributes = function conditionalAttributes(_ref2) {
  var _classNames;

  var fieldName = _ref2.fieldName,
      label = _ref2.label,
      _ref2$helper = _ref2.helper,
      helper = _ref2$helper === void 0 ? '' : _ref2$helper,
      _ref2$isInvalid = _ref2.isInvalid,
      isInvalid = _ref2$isInvalid === void 0 ? false : _ref2$isInvalid;
  // NOTE: aria attributes will be read only when a field gains focus
  var ids = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var attributes = {}; // These components have containing elements that sit in the DOM
  // so if they exist link them to the field programmatically

  var describedby = (0, _dedupe.default)((_classNames = {}, _defineProperty(_classNames, ids.validation.id, isInvalid), _defineProperty(_classNames, ids.helper.id, helper), _classNames));

  if (describedby) {
    attributes['aria-describedby'] = describedby;
  }

  if (label) {
    attributes['aria-labelledby'] = ids.label.id;
  }

  return attributes;
};
/**
 * Generate html attributes for <input>
 * @param  {String}  fieldName - name of the field
 * @param  {Object}  [atts] - standard html attributes to include
 * @param  {String}  label - value of the label for the field
 * @param  {String}  [helper] - (optional) help text that would be provided for the field
 * @param  {boolean} isRequiredField - whether the field should be marked as required
 * @param  {boolean} [isInvalid=false] - (optional) whether the field should be marked as invalid
 * @return {Object} html attributes (varies)
 */


exports.conditionalAttributes = conditionalAttributes;

var inputAttributes = function inputAttributes(_ref3) {
  var fieldName = _ref3.fieldName,
      atts = _ref3.atts,
      label = _ref3.label,
      helper = _ref3.helper,
      isRequiredField = _ref3.isRequiredField,
      _ref3$isInvalid = _ref3.isInvalid,
      isInvalid = _ref3$isInvalid === void 0 ? false : _ref3$isInvalid;
  return _objectSpread({}, commonAttributes({
    fieldName: fieldName,
    atts: atts,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid
  }), conditionalAttributes({
    fieldName: fieldName,
    label: label,
    helper: helper,
    isInvalid: isInvalid
  }), {
    className: (0, _dedupe.default)('field-group__input', {
      'field-group__input--error': isInvalid
    })
  });
};
/**
 * Generate html attributes for <textarea>
 * @param {String}  fieldName - name of the field
 * @param {Object}  atts - standard html attributes to include
 * @param {String}  label - value of the label for the field
 * @param {boolean} isRequiredField - whether the field should be marked as required
 * @param {boolean} [isPlastic=false] - (optional) whether the current Gift Card item is plastic or not
 * @param {String}  [helper=''] - (optional) help text that would be provided for the field
 * @param {boolean} [isInvalid=false] (optional) whether the field should be marked as invalid
 * @return {Object} html attributes (varies)
 */


exports.inputAttributes = inputAttributes;

var textareaAttributes = function textareaAttributes(_ref4) {
  var fieldName = _ref4.fieldName,
      atts = _ref4.atts,
      label = _ref4.label,
      isRequiredField = _ref4.isRequiredField,
      _ref4$isPlastic = _ref4.isPlastic,
      isPlastic = _ref4$isPlastic === void 0 ? false : _ref4$isPlastic,
      _ref4$helper = _ref4.helper,
      helper = _ref4$helper === void 0 ? '' : _ref4$helper,
      _ref4$isInvalid = _ref4.isInvalid,
      isInvalid = _ref4$isInvalid === void 0 ? false : _ref4$isInvalid;
  return _objectSpread({}, commonAttributes({
    fieldName: fieldName,
    atts: atts,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid
  }), conditionalAttributes({
    fieldName: fieldName,
    label: label,
    helper: helper,
    isInvalid: isInvalid
  }), {
    className: (0, _dedupe.default)('field-group__textarea', {
      'field-group__textarea--error': isInvalid,
      'field-group__textarea--plastic': isPlastic,
      'field-group__textarea--elec': !isPlastic
    })
  });
};
/**
 * Generate html attributes for <select>
 * @param {String}  fieldName - name of the field
 * @param {String}  label - value of the label for the field
 * @param {boolean} isRequiredField - whether the field should be marked as required
 * @param {boolean} [isInvalid=false] - whether the field should be marked as invalid
 * @param {boolean} [isCentered=false] - whether the field is centered or not
 * @param {boolean} [transparent=false] - whether the field border is transparent or not
 * @param {Object}  [atts={}] - (optional) standard html attributes to include
 * @param {string}  [helper=''] - (optional) help text that would be provided for the field
 * @return {Object} html attributes (varies)
 */


exports.textareaAttributes = textareaAttributes;

var selectAttributes = function selectAttributes(_ref5) {
  var fieldName = _ref5.fieldName,
      label = _ref5.label,
      isRequiredField = _ref5.isRequiredField,
      _ref5$isInvalid = _ref5.isInvalid,
      isInvalid = _ref5$isInvalid === void 0 ? false : _ref5$isInvalid,
      _ref5$isCentered = _ref5.isCentered,
      isCentered = _ref5$isCentered === void 0 ? false : _ref5$isCentered,
      _ref5$transparent = _ref5.transparent,
      transparent = _ref5$transparent === void 0 ? false : _ref5$transparent,
      _ref5$atts = _ref5.atts,
      atts = _ref5$atts === void 0 ? {} : _ref5$atts,
      _ref5$helper = _ref5.helper,
      helper = _ref5$helper === void 0 ? '' : _ref5$helper;
  return _objectSpread({}, commonAttributes({
    fieldName: fieldName,
    atts: atts,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid
  }), conditionalAttributes({
    fieldName: fieldName,
    label: label,
    helper: helper,
    isInvalid: isInvalid
  }), {
    className: (0, _dedupe.default)('field-group__select', {
      'field-group__select--error': isInvalid,
      'field-group__select--transparent': transparent,
      'field-group__select--centered': isCentered
    })
  });
};
/**
 * Generate html attributes for <label>
 * @param {String}  fieldName - name of the field
 * @param {boolean} isInvalid - field has an error
 * @param {boolean} [isHidden=false] - (optional) the field should be marked as hidden
 * @return {Object} html attributes (id, for(JSX htmlFor), class(JSX className))
 */


exports.selectAttributes = selectAttributes;

var labelAttributes = function labelAttributes(_ref6) {
  var fieldName = _ref6.fieldName,
      isInvalid = _ref6.isInvalid,
      _ref6$isHidden = _ref6.isHidden,
      isHidden = _ref6$isHidden === void 0 ? false : _ref6$isHidden;
  var ids = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var attrs = {
    id: ids.label.id,
    htmlFor: ids.input.id,
    className: (0, _dedupe.default)('field-group__label', {
      'field-group__label--error': isInvalid,
      'field-group__label--hidden': isHidden
    })
  };

  if (isHidden) {
    attrs['aria-hidden'] = true;
  }

  return attrs;
};
/**
 * Generate html attributes for a field maxLength counter.
 * @param {string} id - id of the field
 * @param {boolean} isInvalid - whether the field has an error
 * @return {Object} html attributes (id, class(JSX className))
 */


exports.labelAttributes = labelAttributes;

var counterAttributes = function counterAttributes(_ref7) {
  var id = _ref7.id,
      isInvalid = _ref7.isInvalid;
  return {
    id: id,
    className: (0, _dedupe.default)('field-msg', 'field-msg__counter', {
      'field-msg__counter--error': isInvalid
    })
  };
};
/**
 * Generate html attributes for the containing element of the validation error message
 * @param  {String}  id - id of the field
 * @param  {boolean} [isAssertive=false] - (optional) whether aria-live should be set to assertive or polite
 * @return {Object} html attributes object
 *      TODO: these aria attrs maybe don't do anything since the field is related to
 *      this id with aria-describedby (only announces when focused)
 */


exports.counterAttributes = counterAttributes;

var errorMsgAttributes = function errorMsgAttributes(_ref8) {
  var id = _ref8.id,
      _ref8$isAssertive = _ref8.isAssertive,
      isAssertive = _ref8$isAssertive === void 0 ? false : _ref8$isAssertive;
  return {
    id: id,
    className: 'field-msg field-msg--error',
    'aria-live': isAssertive ? 'assertive' : 'polite',
    'aria-relevant': 'additions text'
  };
};
/**
 * Generate html attributes for the containing element of the validation warning message
 * warning container not programmatically related to the field so it will announce its contents as they change.
 * @param {boolean} [isAssertive=false] - (optional) whether aria-live should be set to assertive or polite
 * @param {boolean} [isAtomic=true] - (optional) whether aria-atomic should be true or false
 * @return {Object} html attributes object (varies)
 */


exports.errorMsgAttributes = errorMsgAttributes;

var warningMsgAttributes = function warningMsgAttributes(_ref9) {
  var _ref9$isAssertive = _ref9.isAssertive,
      isAssertive = _ref9$isAssertive === void 0 ? false : _ref9$isAssertive,
      _ref9$isAtomic = _ref9.isAtomic,
      isAtomic = _ref9$isAtomic === void 0 ? true : _ref9$isAtomic;
  var attrs = {
    className: 'field-msg',
    'aria-live': isAssertive ? 'assertive' : 'polite',
    'aria-relevant': 'additions text'
  };

  if (isAtomic) {
    attrs['aria-atomic'] = true;
  }

  return attrs;
};
/**
 * Generate html attributes for field validation getNumberIcon
 * @param {string} id - id of the field
 * @param {boolean} isInvalid - whether the field has an error
 * @return {Object} html attributes (id, class(JSX className))
 */


exports.warningMsgAttributes = warningMsgAttributes;

var iconAttributes = function iconAttributes(_ref10) {
  var id = _ref10.id,
      isInvalid = _ref10.isInvalid;
  return {
    id: id,
    className: (0, _dedupe.default)('field-icon-validation', {
      'field-icon-validation--valid': !isInvalid,
      'field-icon-validation--error': isInvalid
    })
  };
};
/**
 * Generate html attributes for select field down arrow
 * @param {boolean} isInvalid - whether the field has an error
 * @param {boolean} hasTransparentBackground - whether the field should have a transparent background
 * @return {Object} html attributes (class(JSX className))
 */


exports.iconAttributes = iconAttributes;

var selectArrowAttrs = function selectArrowAttrs(isInvalid, hasTransparentBackground) {
  return {
    className: (0, _dedupe.default)('select-arrow', {
      'select-arrow--error': isInvalid,
      'select-arrow--transparent': hasTransparentBackground && !isInvalid
    })
  };
};
/**
 * Generate html attributes for helper text.
 *
 * If a helper exists it is always in the DOM.
 * It is either hidden with CSS(!meta.active) or always displayed.
 *
 * @param {string} id - id of the field
 * @param {boolean} isInvalid - whether the field has an error
 * @param {boolean} isHidden - whether the field should be hidden
 * @return {Object} html attributes (id, class(JSX className))
 */


exports.selectArrowAttrs = selectArrowAttrs;

var helperAttributes = function helperAttributes(_ref11) {
  var id = _ref11.id,
      isInvalid = _ref11.isInvalid,
      isHidden = _ref11.isHidden;
  var attrs = {
    id: id,
    className: (0, _dedupe.default)('field-msg', 'field-msg--helper', {
      'field-msg--hidden': isHidden,
      'field-msg--error': isInvalid
    })
  };

  if (isHidden) {
    attrs['aria-hidden'] = true;
  }

  return attrs;
};
/**
 * Generate html attributes for fieldContainer
 * @param  {String}  fieldName - name of the field
 * @param  {boolean} [isSmall=false] - (optional) whether the field should be a smaller variant
 * @param  {String} cashbotName - @see getCashbotAttrs
 * @param  {Object} [cashbotOptions={}] - (optional) @see getCashbotAttrs
 * @return {Object} html attributes for the field <div> containing element (className & cashbot-id)
 */


exports.helperAttributes = helperAttributes;

var fieldContainerAttributes = function fieldContainerAttributes(_ref12) {
  var fieldName = _ref12.fieldName,
      _ref12$isSmall = _ref12.isSmall,
      isSmall = _ref12$isSmall === void 0 ? false : _ref12$isSmall,
      cashbotName = _ref12.cashbotName,
      _ref12$cashbotOptions = _ref12.cashbotOptions,
      cashbotOptions = _ref12$cashbotOptions === void 0 ? {} : _ref12$cashbotOptions;
  return _objectSpread({
    className: (0, _dedupe.default)('field-group', {
      'field-group--small': isSmall
    })
  }, (0, _utils.getCashbotAttrs)(fieldName, cashbotName, cashbotOptions));
};

exports.fieldContainerAttributes = fieldContainerAttributes;